<fui-action-button [disabled]="disabled" [ngClass]="{'disabled': disabled}" [title]="title || 'wbo.common.button.cancel'">
    <fui-icon [width]="12" [height]="12" [icon]="'close'"></fui-icon>
</fui-action-button>
